import moment from 'moment';
import React from 'react';
import SideCurrentMatchesRow from '../Matches/SideCurrentMatchesRow';

const MATCH_STATUS_STRINGS = {
  UPCOMING: 'KOMMANDE',
  FINISHED: 'SLUT',
  ONGOING: 'PÅGÅR',
  INTERRUPTED: 'AVBRUTEN',
};

const MATCH_STATUS = {
  UPCOMING: 'UPCOMING',
  FINISHED: 'FINISHED',
  ONGOING: 'ONGOING',
  INTERRUPTED: 'AVBRUTEN',
};

function SideSectionCurrentMatchesItem({ match }) {
  const renderHeader = (item) => {
    const isToday = moment(item.sortId).isSame(moment(), 'day');
    const title = !isToday
      ? moment(item.sortId).format('dddd')
      : `Idag ${moment(item.sortId).format('HH:mm')}`;

    return (
      <div className="col-12 px-2 px-sm-4 pt-2 pt-sm-3 data-container__row">
        <p
          className={
            isToday ? 'badge badge--comp-pink' : 'badge badge--comp-blue-1'
          }
        >
          {title}
        </p>
      </div>
    );
  };

  if (match?.isHeader) {
    return renderHeader(match);
  }

  return <SideCurrentMatchesRow match={match} />;
}

export default SideSectionCurrentMatchesItem;
